import { Grid } from '@material-ui/core';
import { Icons, Typography } from '@nutrien/cxp-components';
import dayjs from 'dayjs';
import React, { useState } from 'react';

import type { AssetProperty } from '../../rxdb/assetDetails/assetDetails.types';
import { YYYYMMDD_DATE_FORMAT } from '../../utilities/constants';
import { useWindowDimensions } from '../../utilities/useWindowDimensions';
import useStyles from './DynamicProperty.styles';

interface Props {
  otherProperties: AssetProperty[];
}

const DynamicProperty: React.FC<Props> = ({ otherProperties }) => {
  const size = useWindowDimensions();
  const [DynamicAsset, setDynamicAsset] = useState<boolean>(false);
  const half = Math.ceil(otherProperties.length / 2);
  const firstHalf = otherProperties.slice(0, half);
  const secondHalf = otherProperties.slice(half, otherProperties.length);
  const classes = useStyles({
    size,
    firstHalfLength: firstHalf?.length,
  });

  const handleViewMore = () => {
    setDynamicAsset(!DynamicAsset);
  };

  const checkDate = (ifDate: string) => {
    const valid = ifDate?.length > 10 ? new Date(ifDate).getTime() > 0 : false;
    return valid;
  };

  return (
    <>
      {half !== 0 && (
        <>
          <Grid className={`${classes.card} ${classes.dynamicProp1}`}>
            <Typography variant="h5" className={classes.otherPropText}>
              Other Properties
            </Typography>
          </Grid>
        </>
      )}
      <Grid xs={12} className={classes.mainGrid}>
        <Grid xs={12} className={`${classes.firstHalfGrid} ${classes.firstHalfBorder}`}>
          {firstHalf &&
            firstHalf.map(
              (val: AssetProperty, idx: number) =>
                (idx < 2 || DynamicAsset) &&
                val?.value?.length > 0 && (
                  <Grid
                    item
                    container
                    xs={12}
                    className={`${classes.firstHalfInnerGrid} ${classes.firstHalfInnerGrid1} ${
                      idx == 0 ? classes.keyValue : classes.keyValue1
                    }`}
                  >
                    <Grid item xs={12} className={classes.secondHalf}>
                      <Grid item xs={6}>
                        <Typography variant="subtitle1" color="textSecondary" fontWeight="normal">
                          {val.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="subtitle1"
                          fontWeight="normal"
                          className={classes.firstHalfValue}
                        >
                          {checkDate(val?.value)
                            ? dayjs(val?.value).format(`${YYYYMMDD_DATE_FORMAT}`)
                            : val?.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ),
            )}
        </Grid>
        <Grid xs={12} className={`${classes.firstHalfGrid} ${classes.secondHalfBorderRadius}`}>
          {secondHalf &&
            secondHalf.map(
              (val: AssetProperty, idx: number) =>
                (idx < 2 || DynamicAsset) &&
                val?.value?.length > 0 && (
                  <Grid
                    item
                    container
                    xs={12}
                    className={`${classes.firstHalfInnerGrid} ${classes.firstHalfInnerGrid1} ${
                      idx == 0 ? classes.keyValue : classes.keyValue1
                    }`}
                  >
                    <Grid item xs={12} className={classes.secondHalf}>
                      <Grid item xs={6}>
                        <Typography variant="subtitle1" color="textSecondary" fontWeight="normal">
                          {val.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="subtitle1"
                          fontWeight="normal"
                          className={classes.firstHalfValue}
                        >
                          {checkDate(val?.value)
                            ? dayjs(val?.value).format(`${YYYYMMDD_DATE_FORMAT}`)
                            : val?.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ),
            )}
        </Grid>
      </Grid>

      {firstHalf.length > 2 && (
        <Grid item justifyContent="center" container xs={12} className={classes.viewMoreGrid}>
          <Typography
            onClick={handleViewMore}
            variant="body2"
            color="primary"
            className={classes.viewMoreAction}
            data-testid="viewMorebutton"
          >
            {DynamicAsset ? (
              <Icons.ChevronUpFeather color="primary" className={classes.viewMoreButton} />
            ) : (
              <Icons.ChevronDownFeather color="primary" className={classes.viewMoreButton} />
            )}
            {DynamicAsset ? `View less` : `View more`}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default DynamicProperty;
